import { render } from "./MarketingChannels.vue?vue&type=template&id=40e078c3&scoped=true"
import script from "./MarketingChannels.vue?vue&type=script&lang=js"
export * from "./MarketingChannels.vue?vue&type=script&lang=js"

import "./MarketingChannels.vue?vue&type=style&index=0&id=40e078c3&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40e078c3"]])

export default __exports__